function * walk (node, depth = 100, parent, key = [], visited = new WeakSet()) {
  if (key.length > depth) return
  if (visited.has(node)) return
  if (!node || typeof node !== 'object') {
    yield [node, parent, key]
    return
  }
  let keys = []; let values; let idx = 0
  if (node && typeof node === 'object') {
    visited.add(node)
    if (Array.isArray(node)) {
      values = node
    } else {
      values = Object.values(node)
      keys = Object.keys(node)
    }
  }
  if (values) {
    yield [node, parent, key]
    parent = node
    for (const element of values) {
      yield * walk(element, depth, parent, [...key, keys[idx] || idx], visited)
      idx++
    }
  }
}

module.exports = walk
